import React from "react";

// hooks
import { makeStyles, createStyles } from "@mui/styles";
import useMe from "../../common/hooks/useMe";

// components
import { Info as InfoIcon } from "@mui/icons-material";
import { Chip } from "@mui/material";
import PlanItem from "./PlanItem";

const DELIMITER = "!";

const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      textAlign: "center",
    },
    reloadButton: {
      margin: "24px auto",
    },
  });
});

const Plan = (props) => {
  const { data: plan = [], date } = props;

  const classes = useStyles();

  const { me = {} } = useMe();
  const { role } = me || {};
  const canCreate = role === "admin" || role === "planner";

  const groupByMeal = (ret, item) => {
    const key = `${item.date}${DELIMITER}${item.meal}`;
    if (!ret[key]) ret[key] = [];
    ret[key].push(item);

    return ret;
  };
  const data = plan.reduce(groupByMeal, {});
  const keys = Object.keys(data);

  const label = () => {
    const label = "Nema podataka.";
    if (!canCreate) return label;

    return `${label} Kreirajte novi plan.`;
  };

  let href = {};
  if (canCreate) {
    href = {
      href: `/create/${date.format("yyyy-MM-DD")}`,
    };
  }

  return (
    <div className={classes.root}>
      {keys.map((key) => {
        return (
          <PlanItem
            key={key}
            date={key.split(DELIMITER)[0]}
            meal={key.split(DELIMITER)[1]}
            data={data[key]}
          />
        );
      })}
      {plan.length === 0 && (
        <Chip
          label={label()}
          avatar={<InfoIcon />}
          component="a"
          clickable
          {...href}
        />
      )}
    </div>
  );
};

export default Plan;
